import { MbXSharedDataKey, MbXWrapperItems } from './types.mobx';
import { mobxWrappedItems } from './wrap-root.mobx';

const createMobxGetter = (
  wrapperItems: MbXWrapperItems,
  getterKey: MbXSharedDataKey,
) => {
  return <T>(wrapperName?: string): T => {
    if (wrapperName) {
      const wrapper = wrapperItems.get(wrapperName);

      if (!wrapper) {
        throw new Error(`No wrapper found with name: ${wrapperName}`);
      }

      return wrapper[getterKey];
    } else {
      if (wrapperItems.size === 0) {
        throw new Error(` no wrapped items!`);
      }
      const values = wrapperItems.values();
      const result = values.next();
      if (result.done || !result.value) {
        throw new Error('No wrapper items found!');
      }
      return result.value[getterKey];
    }
  };
};

export const initMobxRoot = createMobxGetter(mobxWrappedItems, 'root');
export const initMobxEnv = createMobxGetter(
  mobxWrappedItems,
  'environmentData',
);
